export const normalizeAssessmentStatus = (value) => {
    const status = String(value || "").toLowerCase();

    if (
        ["completed", "submitted", "approved"].includes(status)
    ) {
        return "completed";
    }

    if (["in_progress", "draft", "pending"].includes(status)) {
        return "in_progress";
    }

    return "not_started";
};

export const getAssessmentStatusItems = (assessments = {}) => {
    const items = [
        {
            id: "eu-ai-act",
            label: "EU AI Act",
            status: normalizeAssessmentStatus(
                assessments.aiAct?.ai_risk_assessment_status ||
                    assessments.aiAct?.assessmentStatus?.value
            )
        },
        {
            id: "processing-activity",
            label: "Processing Activity",
            status: normalizeAssessmentStatus(
                assessments.processingActivity?.assessmentStatus?.value
            )
        },
        {
            id: "fria",
            label: "FRIA",
            status: normalizeAssessmentStatus(
                assessments.fria?.fria_status ||
                    assessments.fria?.assessmentStatus?.value
            )
        },
        {
            id: "risk-assessment",
            label: "Risk Assessment",
            status: normalizeAssessmentStatus(
                assessments.riskAssessment?.assessmentStatus?.value
            )
        },
        {
            id: "dpia",
            label: "DPIA",
            status: normalizeAssessmentStatus(
                assessments.dpia?.assessmentStatus?.value
            )
        }
    ];

    if (assessments.conformity?.provider_conformity_required) {
        items.push({
            id: "ce-conformity",
            label: "CE Conformity",
            status: normalizeAssessmentStatus(
                assessments.conformity?.provider_conformity_status
            )
        });
    }

    return items;
};

export const PRIVACY_RISK_SCORE = {
    high: { title: "High Risk", color: "#EB5757" },
    low: { title: "Low Risk", color: "#1CBB8C" },
    not_assessed: { title: "Not Assessed", color: "#828282" }
};

export const getPrivacyRiskScore = (level) => {
    return PRIVACY_RISK_SCORE[level] || PRIVACY_RISK_SCORE.not_assessed;
};
